declare var window: any;
declare var _openLinkTimer: any;
declare var __portal: IPortalSettings;

declare var modalOpen: (id: string) => void;
declare var closeAllModals: () => void;

export const Portal = typeof __portal !== 'undefined' ? __portal : null;
export const isNullOrWhiteSpace = (str: string): boolean => !str || str === null || str.match(/^\s*$/) !== null;
export const currency = (_z: number): string => (_z == undefined ? '$0.00' : `\$${_z.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`);
export const currency_noNegatives = (_z: number): string => (_z == undefined ? '$0.00' : `\$${(_z < 0 ? 0 : _z).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`);

export enum ValidationMessages {
    TooShort = 'Entry is too short, please lengthen your entry',
    TooLong = 'Entry is too long, please shorten your entry',
}

export enum RenderType {
    Normal = 1,
    Zoom,
    Popout,
    Other,
}

declare global {
    // tslint:disable-next-line
    interface String {
        truncate(n: number, useDots: boolean): string;
    }
}

String.prototype.truncate = function (this: string, n: number, useDots: boolean = false) {
    return this.substr(0, n - 1) + (useDots && this.length > n ? '&hellip;' : '');
};

export const isInputError = (v: IValidationObject) => v.isError && v.alive;
export const setInputError = (v: IValidationObject, msg: string) => {
    v.msg = msg;
    v.alive = true;
    v.isError = true;
};

export const getPhoneNumberFormatted = (_p: string) => {
    const cleaned = `${_p}`.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return _p;
};

export const getPhoneHREF = () => {
    return `tel:${Portal?.CustomerServicePhone.replace(/\D/g, '')}`;
};

export const roundF = (value: number, precision: number) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
};

export const capitalize = (str: string): string => (str.length ? str[0].toUpperCase() + str.slice(1) : str);
export const suggIsNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

/* tslint:disable:no-unnecessary-callback-wrapper */
window.openLink = (_url: string, _blank?: boolean) => openLink(_url, _blank);
/* tslint:enable:no-unnecessary-callback-wrapper */
export const openLink = (_url: string, _blank?: boolean) => {
    try {
        if (_openLinkTimer != undefined) {
            clearTimeout(_openLinkTimer);
        }
        if (typeof _url === 'undefined') {
            return;
        }
        if (typeof _blank !== 'undefined') {
            window.open(_url, '_newtab');
        } else {
            document.location = _url;
        }
    } catch (err) {
        if (_url != undefined) {
            document.location = _url;
        }
    }
};

export const modal = (_id: string) => {
    if (typeof modalOpen === 'function') {
        modalOpen(_id);
    }
};

export const hideAllModals = () => {
    if (typeof closeAllModals === 'function') {
        closeAllModals();
    }
};

export const debounce = (func: any, delay: number) => {
    let timer: any;
    return function (event: any) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, delay, event);
    };
};

export const getParameterByName = (name: string, url = window.location.href) => {
    name = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const ariaPulse = () => {
    const caro_prev: HTMLElement[] = [].slice.call(document.getElementsByClassName('swiper-button-prev') as HTMLCollectionOf<HTMLElement>);
    const caro_next: HTMLElement[] = [].slice.call(document.getElementsByClassName('swiper-button-next') as HTMLCollectionOf<HTMLElement>);
    caro_prev.map(x => {
        x.ariaLabel = 'previous';
        x.role = 'button';
    });
    caro_next.map(x => {
        x.ariaLabel = 'next';
        x.role = 'button';
    });
};

export const prod_entity_zoom_open = (_id: string, sender: HTMLElement, offset_top: number, offset_left: number, _w: string, _h: string, _title: string, _desc: string, _color?: string) => {
    const rect = sender.getBoundingClientRect();
    const div = document.createElement('div');
    const p = document.createElement('div');
    const p2 = document.createElement('div');
    const img = document.createElement('img');
    console.log(rect);
    // console.log(sender);
    if (_color) {
        img.style.backgroundColor = `#${_color}`;
    }
    img.src = sender.getAttribute('data-img') as string;
    div.className = 'prod-img-zoom';
    div.style.width = _w;

    img.style.width = _w;
    img.style.height = _h;
    div.style.top = `${Math.floor(rect.top) + offset_top - 10}px`;
    div.style.left = `${Math.floor(rect.left) + offset_left}px`;
    // console.log(rect.top, div.style.top, offset_top);
    p.innerText = _title;
    p2.innerText = _desc;
    div.appendChild(img);
    if (_title && _title.length > 0) {
        div.appendChild(p);
    }
    if (_desc && _desc.length > 0) {
        div.appendChild(p2);
    }
    (document.getElementById('prod-wrapper') as HTMLElement).appendChild(div);
    // (document.getElementById(_id) as HTMLElement).appendChild(div);
    //moulding-inner
    sender.appendChild(div);
};

export const prod_entity_zoom_destroy = () => {
    const modals = document.getElementsByClassName('prod-img-zoom') as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < modals.length; i++) {
        modals[i].remove();
    }
};

export const webp = (s: string): string => {
    return s.toLowerCase().replace('.jpg', '.webp').replace('.png', '.webp').replace(/ /g, '%20');
};

export const getCookieValue = (s: string): string => {
    let cookieName = `${s}=`;
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return '';
};

export const getAntiForgeryToken = () => {
    const el = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement | null;

    return el?.value ?? '';
};
